var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-range-picker',_vm._b({attrs:{"show-time":_vm.showTime},on:{"change":_vm.changeHandle},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'a-range-picker',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }